export class ContactInteraction {
    static jsonMap = {
        idContact: { key: 'idContact', optional: true },
        nom: { key: 'nom', optional: true, default: '' },
        prenom: { key: 'prenom', optional: true, default: '' },
        raisonsociale: { key: 'raisonsociale', optional: true, default: '' },
        idEntreprise: { key: 'idEntreprise', optional: true }
    };

    public idContact: number;
    public nom: string;
    public prenom: string;
    public raisonsociale: string;
    public idEntreprise: number;
}
